import { getToken, setToken, removeToken } from '../../utils/auth'

const userInfo = {
    state: {
        token: getToken(),
        userName: '',
        userId: '',
        userEmail: '',
        phone:'',
        inner: 0,
    },
    mutations: {
        setUserName: (state, userName) => {
            state.userName = userName
        },
        setUserId: (state, userId) => {
            state.userId = userId
        },
        setUserEmail: (state, userEmail) => {
            state.userEmail = userEmail
        },
        setIsInner: (state, inner) => {
            state.inner = inner
        },
        setPhone: (state, phone) => {
            state.phone = phone
        },
        setToken: (state, token) => {
            state.token = token
        }
    },
    getters: {
        getUserId: state => state.userName,
        getUserName: state => state.userId,
        getUserEmail: state => state.userEmail,
        getUserInner: state => state.inner,
        getUserPhone: state => state.phone,
        getToken:  state => state.token,
    },
    actions: {
        setUserInfo({ commit }, userInfo) {
            if (userInfo['userName']) commit('setUserName', userInfo['userName'])
            if (userInfo['userId']) commit('setUserId', userInfo['userId'])
            if (userInfo['email']) commit('setUserEmail', userInfo['email'])
            if (userInfo['phone']) commit('setPhone', userInfo['phone'])
            if (userInfo['csrfToken']) commit('setToken', userInfo['csrfToken'])
            setToken(userInfo['csrfToken'])
            if (userInfo['isInner'] === 1) {
                commit('setIsInner', 1)
            } else {
                commit('setIsInner', 0)
            }
        },
        removeUserInfo({ commit }, res) {
            commit('setUserName', '')
            commit('setUserId', '')
            commit('setUserEmail', '')
            commit('setPhone', '')
            commit('setToken', '')
            removeToken()
            commit('setIsInner', 0)
            commit('setDefRouters', [])
        },
    }
}

export default userInfo
